import PageLayout from '@app/components/PageLayout';
import Investor from '@modules/investor/components/Investor';
const InvestorStart = () => {
    return (<PageLayout>
            <Investor />
        </PageLayout>);
};
export default InvestorStart;
